import React from 'react';
import {
    ArrivalDetails,
    CarrierNameAndArrivalWrapper,
    CarrierTitle,
    DeliveryAddressWrapper,
    DeliveryWrapper,
    ButtonAndPriceWrapper,
    PriceDetails,
} from './styled';
import { Button, Image } from '~/shared/components';
import { ShippingMethod } from '~/lib/data-contract/salesforce';
import { useUtils } from '~/shared/hooks/useUtils';
import { useTranslation } from '~/shared/utils/translation';

type Props = {
    setCarrier?: (variant: ShippingMethod) => void;
    optionList?: Array<ShippingMethod>;
};

export const DeliveryAddressList = ({ setCarrier, optionList }: Props) => {
    const { translate } = useTranslation();
    const { getPriceLabel } = useUtils();

    return (
        <DeliveryAddressWrapper>
            {optionList?.map((deliveryOption) => {
                return (
                    setCarrier && (
                        <DeliveryWrapper key={deliveryOption.id} data-testid={'delivery-option'}>
                            <CarrierNameAndArrivalWrapper>
                                {deliveryOption?.c_image && (
                                    <Image
                                        src={deliveryOption.c_image}
                                        alt={deliveryOption.name ?? ''}
                                        height={24}
                                        width={35}
                                        layout="intrinsic"
                                        objectFit="contain"
                                    />
                                )}

                                <CarrierTitle>{deliveryOption?.name ?? ''}</CarrierTitle>
                                <ArrivalDetails>
                                    {deliveryOption?.c_estimatedArrivalTime ?? ''}
                                </ArrivalDetails>
                            </CarrierNameAndArrivalWrapper>

                            <ButtonAndPriceWrapper>
                                {!!deliveryOption?.price && (
                                    <PriceDetails>
                                        {getPriceLabel(deliveryOption.c_adjustedPrice)}
                                    </PriceDetails>
                                )}

                                <Button
                                    aria-label={`Vælg ${deliveryOption?.name}`}
                                    data-testid="delivery-option-cta"
                                    small
                                    onClick={() => setCarrier(deliveryOption)}
                                >
                                    {translate('checkout.delivery.select')}
                                </Button>
                            </ButtonAndPriceWrapper>
                        </DeliveryWrapper>
                    )
                );
            })}
        </DeliveryAddressWrapper>
    );
};
